import React from 'react';
import { Spinner } from 'react-bootstrap';

import './loader.css';

export const Loader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center loader-container">
      <Spinner animation="border" />
    </div>
  )
}
